import { render, staticRenderFns } from "./Gather.vue?vue&type=template&id=64bdc548&"
import script from "./Gather.vue?vue&type=script&lang=js&"
export * from "./Gather.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports